import { capacitorService } from '../../application/CapacitorService';
import { StorageRepository } from './StorageRepository';
import { StorageRepositoryCapacitor } from './StorageRepositoryCapacitor';
import { StorageRepositoryLocal } from './StorageRepositoryLocal';

let storageRepository: StorageRepository;

if (capacitorService.isNative()) {
  storageRepository = new StorageRepositoryCapacitor();
} else {
  storageRepository = new StorageRepositoryLocal();
}

export { storageRepository };
